__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.10.1-44e7122-18439/_next/";